import {
	DEFAULT_COMPONENTS_STYLING,
	DefaultIconFactory,
	DefaultStyledTooltipComponents,
	type TkComponentStyles,
} from "@constellation-academy/framework-react-components";
import { Button } from "primereact/button";
import styled from "styled-components";
import tw from "twin.macro";
import { HorizontalElementSpacingWrapper } from "./default-spacings.component";
import { tkaAdminDialogStyles } from "./dialog";
import { tkaAdminFieldStyles } from "./field";
import { TkaAdminFormStyles } from "./form";
import { tkaAdminInputCalendarStyles } from "./input-calendar";
import { tkaAdminInputChipsStyles } from "./input-colorpicker";
import { tkaAdminInputDropdownStyles } from "./input-dropdown";
import { tkaAdminInputMultiSelectStyles } from "./input-multiselect";
import { tkaAdminInputNumberStyles } from "./input-number";
import { tkaAdminInputPasswordStyles } from "./input-password";
import { tkaAdminInputSwitchStyles } from "./input-switch";
import { tkaAdminInputTextStyles } from "./input-text";
import { tkaAdminInputTextAreaStyles } from "./input-textarea";
import { tkaAdminTableStyles } from "./table";

export const TkaAdminTheme: TkComponentStyles = {
	...DEFAULT_COMPONENTS_STYLING,
	...tkaAdminFieldStyles,
	...TkaAdminFormStyles,
	...tkaAdminTableStyles,
	...tkaAdminDialogStyles,
	...tkaAdminInputCalendarStyles,
	...tkaAdminInputChipsStyles,
	...tkaAdminInputChipsStyles,
	...tkaAdminInputDropdownStyles,
	...tkaAdminInputMultiSelectStyles,
	...tkaAdminInputNumberStyles,
	...tkaAdminInputPasswordStyles,
	...tkaAdminInputSwitchStyles,
	...tkaAdminInputTextStyles,
	...tkaAdminInputTextAreaStyles,
	HorizontalElementSpacingWrapper,
	FormDialog: {
		...DEFAULT_COMPONENTS_STYLING.FormDialog,
		FormDialogButtonContainer: styled.div`
			display: flex;
			justify-content: flex-end;
		`,
		SaveText: "Speichern",
		CancelText: "Abbrechen",
	},
	DialogLogic: {
		...DEFAULT_COMPONENTS_STYLING.DialogLogic,
		ButtonContainer: styled.div`
			display: flex;
			justify-content: flex-end;
		`,
	},
	DeleteButton: {
		...DEFAULT_COMPONENTS_STYLING.DeleteButton,
		Icon: "pi pi-trash",
		Title: (selectedIdsLength, singularName, pluralName) =>
			selectedIdsLength === 1 ? `${singularName} löschen` : `${pluralName} löschen`,
		Content: (selectedIdsLength, singularName, pluralName) =>
			`Möchten Sie ${
				selectedIdsLength === 1 ? `diesen ${singularName}` : `diese ${pluralName}`
			} wirklich löschen? Dies kann nicht rückgängig gemacht werden.`,
	},
	Button: {
		StyledButton: styled(Button as any)`
			border-radius: 5px;
		` as any,
	},
	Pagination: {
		Label: "Mehr laden",
		PaginationContainer: tw.div`tw-flex tw-justify-center tw-items-center`,
	},
	Icon: {
		IconFactory: DefaultIconFactory,
	},
	Tooltip: {
		...DefaultStyledTooltipComponents.Tooltip,
	},
};
